var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.options !== null && _vm.options.attrs !== null
    ? _c("el-quarter", {
        attrs: {
          placeholder: _vm.options.attrs.placeholder,
          size: _vm.size,
          editable: false,
        },
        model: {
          value: _vm.options.value,
          callback: function ($$v) {
            _vm.$set(_vm.options, "value", $$v)
          },
          expression: "options.value",
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }